import { useGLTF } from '@react-three/drei';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

export default function Grilles() {
    const grilled = useGLTF('./models/grilled.glb');
    const grilleg = useGLTF('./models/grilleg.glb');

    const grilleDroiteRef = useRef();
    const grilleGaucheRef = useRef();

    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/manifestants') {
            gsap.to(grilleDroiteRef.current.rotation, {
                y: 0, 
                duration: 4,
                ease: 'power2.inOut',
            });
            gsap.to(grilleGaucheRef.current.rotation, {
                y: 0, 
                duration: 4,
                ease: 'power2.inOut',
            });
        } else {
            gsap.to(grilleDroiteRef.current.rotation, {
                y: - Math.PI / 2.25,
                duration: 4,
                ease: 'power2.inOut',
            });
            gsap.to(grilleGaucheRef.current.rotation, {
                y: Math.PI / 2.25,
                duration: 4,
                ease: 'power2.inOut',
            });
        }
    }, [location.pathname]);

    return (
        <>
            <mesh
                ref={grilleDroiteRef}
                position={[-0.564366, 0, -10.3165]}
                geometry={grilled.nodes.grilled.geometry}
                onClick={(event) => event.stopPropagation()}
                onPointerEnter={(event) => event.stopPropagation()}
            >
                <meshStandardMaterial color="#392821" />
            </mesh>
            <mesh
                ref={grilleGaucheRef}
                position={[-3.71402, 0, -10.3165]}
                geometry={grilleg.nodes.grilleg.geometry} 
                onClick={(event) => event.stopPropagation()}
                onPointerEnter={(event) => event.stopPropagation()}
            >
                <meshStandardMaterial color="#392821" />
            </mesh>
        </>
    );
}